module.exports = __webpack_public_path__ + "static/media/hand-icon.08d709ea.svg";